
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

const ListingHeader = () => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <h1 className="text-2xl font-bold text-gray-900">My Listings</h1>
      <Button asChild>
        <Link to="/dashboard/add-listing">
          <Plus className="mr-2 h-4 w-4" />
          Add New Listing
        </Link>
      </Button>
    </div>
  );
};

export default ListingHeader;
